import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

const clientToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;
const applicationId = process.env.REACT_APP_DATADOG_RUM_APP_ID;
const environmentName = process.env.REACT_APP_ENVIRONMENT_NAME ?? 'local';
const isLocal = environmentName === 'local';

const datadog = { logs: undefined, rum: undefined };
if (clientToken && !isLocal) {
  const datadogBaseConfig = {
    clientToken,
    env: environmentName,
    service: 'tc3-client-portal',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    version: require('../package.json').version,
    allowedTracingUrls: [process.env.REACT_APP_DATADOG_RUM_TRACING_ORIGIN],
  };

  // Logs-only options, kept out of the RUM init:
  // - forwardReports: CSP violation reports go to Logs as well as RUM (TC3-17078);
  // - forwardConsoleLogs: SDK v7 no longer forwards console.error under forwardErrorsToLogs; keeps the v6 behaviour.
  datadogLogs.init({ ...datadogBaseConfig, forwardReports: ['csp_violation'], forwardConsoleLogs: ['error'] });
  datadog.logs = datadogLogs;

  if (applicationId) {
    datadogRum.init({
      applicationId,
      ...datadogBaseConfig,
    });

    datadog.rum = datadogRum;
  }
}

export default datadog;
